import { render } from "./PostProfilePicture.vue?vue&type=template&id=20725ec2&ts=true"
import script from "./PostProfilePicture.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostProfilePicture.vue?vue&type=script&setup=true&lang=ts"

import "./PostProfilePicture.vue?vue&type=style&index=0&id=20725ec2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/PostProfilePicture.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20725ec2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20725ec2', __exports__)) {
    api.reload('20725ec2', __exports__)
  }
  
  module.hot.accept("./PostProfilePicture.vue?vue&type=template&id=20725ec2&ts=true", () => {
    api.rerender('20725ec2', render)
  })

}


export default __exports__